<template>
  <DialogoFormulario title="Transferir estoque">
    <template v-slot="{ form, errors }">
      <v-text-field
        v-model="form.origem"
        label="Origem"
        disabled
      ></v-text-field>
      <v-text-field
        v-model="form.produto"
        label="Produto"
        disabled
      ></v-text-field>
      <v-text-field v-model="form.destino" label="Destino"></v-text-field>
      <v-text-field
        v-model="form.quantidade"
        label="Quantidade"
        type="number"
      ></v-text-field>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "../../dialogos/DialogoFormulario.vue";

export default {
  components: { DialogoFormulario }
};
</script>
